import Vue from 'vue'
import Vuex, { Module } from 'vuex'
import { vuexfireMutations, firestoreAction } from 'vuexfire'
import firebase from 'firebase/app'

import { db, FieldValue, Timestamp } from '../db'
import router from '@/router'
import { initialCard } from '@/models/KaiwaCard'

const defaultDeck = { title: '', description: '', visibility: 'unlisted' }

const defaultCards = [
    {
        ...initialCard,
        title: '挨拶',
    }
]

export const draftDeck: Module<any, any> = {
    namespaced: true,
    state: {
        deck: defaultDeck,
        cards: defaultCards,
        loading: false,
        createdDecks: []
    },
    mutations: {
        ...vuexfireMutations,
        setLoading: (state, { loading }) => {
            state.loading = loading
        },
        storeDraftDeck: (state, { deck, cards }) => {
            state.deck = deck
            state.cards = cards
            localStorage.setItem('draft-deck', JSON.stringify(deck))
            localStorage.setItem('draft-cards', JSON.stringify(cards))
        },
        setDraftDeck: (state, { deck, cards }) => {
            state.deck = deck
            state.cards = cards
        },
        reset: (state) => {
            state.deck = defaultDeck
            state.cards = []
            localStorage.removeItem('draft-deck')
            localStorage.removeItem('draft-cards')
        },
        addCreatedDeck: (state, { deck }) => {
            state.createdDecks = [deck, ...state.createdDecks];
            localStorage.setItem('created-decks', JSON.stringify(state.createdDecks))
        },
        restoreCreatedDeck: (state) => {
            const item = localStorage.getItem('created-decks');
            if (item) {
                state.createdDecks = JSON.parse(item)
            }
        }
    },
    actions: {
        createDraftDeck({ commit, state }) {
            if (router.currentRoute.path === '/create') {
                return
            }

            commit('setLoading', { loading: true })

            commit('setDraftDeck', { deck: defaultDeck, cards: defaultCards })

            commit('restoreCreatedDeck')

            commit('setLoading', { loading: false })

            router.push({ path: '/create' })
        },
        forkDeck({ commit, state }, { deck, cards }) {
            commit('setLoading', { loading: true })

            commit('reset')

            commit('setDraftDeck', { deck: JSON.parse(JSON.stringify({ ...JSON.parse(JSON.stringify(deck)), visibility: 'unlisted' })), cards: JSON.parse(JSON.stringify(cards)) })

            commit('restoreCreatedDeck')

            commit('setLoading', { loading: false })

            router.push({ path: '/create' })
        },
        updateDraftDeck({ commit, state }, { deck, cards }) {
            commit('storeDraftDeck', { deck, cards })
        },
        restoreDraftDeck({ commit }) {
            try {
                const deckJson = localStorage.getItem('draft-deck')
                const cardsJson = localStorage.getItem('draft-cards')
                if (deckJson && cardsJson) {
                    const deck = JSON.parse(deckJson)
                    const cards = JSON.parse(cardsJson)
                    commit('storeDraftDeck', { deck, cards })
                }
            } catch (e) {
                console.log(e)
            }
        },
        resetDraftDeck({ commit, state }) {
            commit('reset')
        },
        createDeck({ commit, state }) {
            commit('setLoading', { loading: true })

            const docRef = db.collection('decks').doc()
            const deckId = docRef.id

            docRef
                .set({
                    ...state.deck,
                    deckId,
                    createdAt: FieldValue.serverTimestamp(),
                    updatedAt: FieldValue.serverTimestamp(),
                })
                .then(() => {
                    return Promise.all(state.cards.map((card: any) => {
                        const cardDocRef = db.collection(`decks/${deckId}/cards`).doc()
                        const cardId = cardDocRef.id
                        return cardDocRef
                            .set({
                                ...card,
                                cardId,
                                deckId,
                                visibility: state.deck.visibility,
                                createdAt: FieldValue.serverTimestamp(),
                                updatedAt: FieldValue.serverTimestamp(),
                            })
                    })).then(() => {
                        return docRef.get().then(doc => {
                            commit('setLoading', { loading: false })
                            commit('reset')
                            commit('addCreatedDeck', { deck: doc.data() })
                            router.push({ path: `/decks/${doc.id}` })
                        })
                    })
                })
                .finally(() => {
                    commit('setLoading', { loading: false })
                })

        },
        fetchCreatedDecks({ commit }) {
            commit('restoreCreatedDeck')
        }
    },
    getters: {
        getDraftDeck: (state) => {
            return state.deck
        },
        getDraftCards: (state) => {
            return state.cards
        },
        loading: (state) => {
            return state.loading
        },
        hasDraft: (state => {
            return !!localStorage.getItem('draft-deck')
        }),
        getCreatedDecks: (state) => {
            return state.createdDecks
        },
    }
}